import type { DaAnswerStatusFilter } from "#/components/exam-results/context/descriptive/types";
import { RemoveRound } from "@monta/icons";
import clsx from "clsx";
import { useDaContext } from "../../context/descriptive/context";
import styles from "./styles.module.scss";

type Props = {
  moduleGroupFilters: { label: string; value: string }[];
};

const filterItems: { label: string; value: DaAnswerStatusFilter }[] = [
  { label: "درست", value: "corrects" },
  { label: "غلط", value: "incorrects" },
  { label: "نزده", value: "no-answers" },
  { label: "همه", value: "all" }
];

const MobileDescriptiveAnswerReportFilter = (props: Props) => {
  const { setFilters, setPage, filters } = useDaContext();
  const { moduleGroupFilters } = props;

  return (
    <section className={styles["filter-mobile"]}>
      {filterItems.map((item, key) => {
        const handleClick = () => {
          if (item.value === filters.selectedAnswerStatus) {
            setFilters({ ...filters, selectedAnswerStatus: undefined });
          } else {
            setFilters({ ...filters, selectedAnswerStatus: item.value });
          }
          setPage(1);
        };
        return (
          <button
            key={key + "filter"}
            className={clsx(
              styles["filter-mobile__item"],
              item.value === filters.selectedAnswerStatus &&
                styles["filter-mobile__item--active"]
            )}
            onClick={handleClick}
          >
            {item.label}
            {item.value === filters.selectedAnswerStatus && (
              <RemoveRound onClick={handleClick} size={20} />
            )}
          </button>
        );
      })}
      <span className={styles["filter-mobile__divider"]}>|</span>
      {moduleGroupFilters.map((item, key) => {
        const handleClick = () => {
          if (Number(item.value) === filters.selectedModuleGroup) {
            setFilters({ ...filters, selectedModuleGroup: undefined });
          } else {
            setFilters({ ...filters, selectedModuleGroup: Number(item.value) });
          }
          setPage(1);
        };
        return (
          <button
            key={key + "filter"}
            className={clsx(
              styles["filter-mobile__item"],
              Number(item.value) === filters.selectedModuleGroup &&
                styles["filter-mobile__item--active"]
            )}
            onClick={handleClick}
          >
            {item.label}
            {Number(item.value) === filters.selectedModuleGroup && (
              <RemoveRound onClick={handleClick} size={20} />
            )}
          </button>
        );
      })}
    </section>
  );
};

export default MobileDescriptiveAnswerReportFilter;
